import { getUserInfo } from '@/api/userinfo'

const userModule = {
  namespaced: true,
  state: {
    amount: 0,
  },
  getters: {
    amount: state => state.amount,
  },
  mutations: {
    setAmount(state, amount) {
      state.amount = amount
    },
  },
  actions: {
    async fetchUserInfo({ commit }) {
      const res = await getUserInfo()
      commit('setAmount', res.amount || 0)
    },
    updateAmount({ commit }, amount) {
      commit('setAmount', amount)
    },
  }
}

export default userModule
